import { render, staticRenderFns } from "./Renewal.vue?vue&type=template&id=4fadc428&scoped=true"
import script from "./Renewal.vue?vue&type=script&lang=ts"
export * from "./Renewal.vue?vue&type=script&lang=ts"
import style0 from "./Renewal.vue?vue&type=style&index=0&id=4fadc428&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fadc428",
  null
  
)

export default component.exports